import { render, staticRenderFns } from "./UnpaidInvoices.vue?vue&type=template&id=1c9b6b5b&scoped=true"
import script from "./UnpaidInvoices.vue?vue&type=script&lang=js"
export * from "./UnpaidInvoices.vue?vue&type=script&lang=js"
import style0 from "./UnpaidInvoices.vue?vue&type=style&index=0&id=1c9b6b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9b6b5b",
  null
  
)

export default component.exports